import memoize from 'fast-memoize';

import { TOGGLE_PREV_POPOVER } from 'actionTypes/popover';
import createAction from 'helpers/createAction';

export const togglePrevPopover = memoize(createAction(TOGGLE_PREV_POPOVER));
